import i18n from './i18nHelpers'

export default {
  isOnlyIroningServiceProvider (professional) {
    let result = false
    if (professional.professional_services.length === 1) {
      for (const professionalService of professional.professional_services) {
        if (professionalService.service_id === 2) {
          result = true
          break
        }
      }
    }
    return result
  },
  getInconvenientPets (professional) {
    const petTypes = []
    for (const professionalPetType of professional.professional_pet_types) {
      let petTypeName = (i18n.locale === 'th') ? professionalPetType.pet_type.name_th : professionalPetType.pet_type.name_en
      if (professionalPetType.pet_type.is_other === 1) {
        petTypeName = professionalPetType.other_remark
      }
      petTypes.push(petTypeName)
    }
    return petTypes.join(', ')
  }
}



// WEBPACK FOOTER //
// ./src/helpers/professionalHelpers.js